<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <div class="mx-auto" :style="{maxWidth: maxWidth}">
    <p class="font-weight-bold text-center" v-if="title">{{title}}</p>
    <canvas :id="chartId" width="400" height="400"></canvas>
  </div>
</template>
<!--eslint-enable-->

<script>
  import Vue from 'vue';
  import Chart from 'chart.js';

  export default {
    components: {},
    props: {
      series: {
        type: Object,
        required: true,
      },
      chartId: {
        required: true,
        type: String,
      },
      maxWidth: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: false,
      },
      xTitle: {
        type: String,
        required: false,
      },
      yTitle: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        chart: null,
      };
    },
    mounted() {
      this.setUpChart();
    },
    methods: {
      setUpChart() {
        Vue.nextTick(() => {
          let ctx = document.getElementById(this.chartId);

          // eslint-disable-next-line no-unused-vars
          this.chart = new Chart(ctx, {
            type: 'bar',
            data: {
              datasets: [{
                label: '',
                data: this.series.data,
                backgroundColor: [
                  '#845ec2',
                  '#d65db1',
                  '#ff6f91',
                  '#ff9671',
                  '#ffc75f',
                  '#f9f871',
                  '#2c73d2',
                  '#008e9b',
                  '#fbeaff',
                  '#00c9a7',
                  '#c34a36',
                  '#e1edf2'
                 ]
              }],
              labels: this.series.labels
            },
            options: {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: this.yTitle || ''
                  },
                  ticks: {
                    beginAtZero: true
                  }
                }],
                xAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: this.xTitle || ''
                  }
                }]
              },
              // title: {
              //   display: true,
              //   text: 'Custom Chart Title'
              // }
            }
        });
          ctx.onclick = (evt) => {
            let activePoints = this.chart.getElementsAtEventForMode(evt, 'point', this.chart.options);
            let firstPoint = activePoints[0];
            let label = this.chart.data.labels[firstPoint._index];
            let value = this.chart.data.datasets[firstPoint._datasetIndex].data[firstPoint._index];
            this.$emit('data-click', {label: label, value: value});
          };

        });
      }
    },
  };
</script>
